"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TransitionHeightMode = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./TransitionHeight.less");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var TransitionHeightMode = {
  Auto: 'auto',
  Full: '100%'
};
exports.TransitionHeightMode = TransitionHeightMode;
var nextAnimationFrame = function nextAnimationFrame() {
  return new Promise(requestAnimationFrame);
};

/**
 * Animate an element's height changes. Strategy based on:
 * https://css-tricks.com/using-css-transitions-auto-dimensions/#technique-3-javascript
 *
 * Example usage:
 *
 *    <TransitionHeight
 *      contentKey={content}
 *      height={'auto' | '100%'}
 *    >
 *      {content === 'content-1' && <h1><img src="large-image.jpg" /> Content with some height</h1>}
 *      {content === 'content-2' && <p>Content with different height</p>}
 *    </TransitionHeight>
 *
 * Note: we have to use a class component in order to hook onto the `getSnapshotBeforeUpdate`
 * lifecycle event as there's no equivalent for functional components.
 *
 * Note: this component mutates the DOM directly instead of letting React do it. This is definitely
 * risky and not ideal, but using state and waiting for updates to flush seemed to be too brittle
 * for the type of instantaneous control needed. That said, since it doesn't store any state
 * itself, it should only ever re-render when props change, which should be OK since that means
 * the height transition process will be kicking off again.
 *
 * @param {any} contentKey unique key for content for determining if height is about to change
 * @param {TransitionHeightMode} height height: auto vs 100% for current content
 * @param {string} className className to apply to the generated container component
 */
var TransitionHeight = /*#__PURE__*/function (_React$Component) {
  _inherits(TransitionHeight, _React$Component);
  var _super = _createSuper(TransitionHeight);
  function TransitionHeight() {
    var _this;
    _classCallCheck(this, TransitionHeight);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.containerRef = /*#__PURE__*/_react.default.createRef();
    _this.childRef = /*#__PURE__*/_react.default.createRef();
    _this.onTransitionEnd = null;
    return _this;
  } // Root container element
  // Child wrapper element, serves as a proxy for measuring the content within
  // For storing pending event listeners we need to cleanup an unmount
  _createClass(TransitionHeight, [{
    key: "containerEl",
    get: function get() {
      return this.containerRef.current;
    }
  }, {
    key: "childEl",
    get: function get() {
      return this.childRef.current;
    }

    // Set initial container height on mount (since there's no transition process)
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.containerEl.style.height = this.props.height;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.onTransitionEnd) {
        this.onTransitionEnd();
      }
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      // If content is about to change, measure its current height and freeze at that value.
      // Technically we should not be mutating in this method, but it's the only possible way!
      if (prevProps.contentKey !== this.props.contentKey) {
        // This lifecycle method doesn't get called on first render, so childEl will always exist
        var childHeight = this.childEl.offsetHeight;
        // Freeze its height to the current measurement
        this.childEl.style.height = "".concat(childHeight, "px");
        // If subsequent content is taller, allow it to appear but without scroll bars
        this.childEl.style.overflowY = 'visible';
        return {
          childHeight: childHeight
        };
      }
      return null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      // If content changed, execute transition to the new target height mode
      if (prevProps.contentKey !== this.props.contentKey) {
        this.transitionTo(this.props.height, {
          fromHeight: snapshot.childHeight
        });
      }
    }
  }, {
    key: "transitionTo",
    value: function () {
      var _transitionTo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(height, _ref) {
        var _this2 = this;
        var fromHeight, transition, targetHeight, childHeight, maxHeight;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fromHeight = _ref.fromHeight;
                // Turn off transition so style change won't trigger it
                transition = this.containerEl.style.transition;
                this.containerEl.style.transition = '';

                // Supposedly we need to wait for a new frame before the style change will have taken effect
                _context.next = 5;
                return nextAnimationFrame();
              case 5:
                // Explicitly give the container the child's previous height and restore its transition
                this.containerEl.style.height = "".concat(fromHeight, "px");
                this.containerEl.style.transition = transition;
                // Have child render using its instrinsic height so we can measure it
                this.childEl.style.height = 'auto';

                // Wait a frame so child's new intrinsic height is measurable
                _context.next = 10;
                return nextAnimationFrame();
              case 10:
                // For TransitionHeightMode.Auto, we want to animate to the content's new intrinsic height. But if it's
                // taller than available space, we only want to animate height to that available space (100%).
                // Probably brittle, but for now we just discern max available height via our parent's height.
                if (height === TransitionHeightMode.Auto) {
                  childHeight = this.childEl.offsetHeight;
                  maxHeight = this.containerEl.parentElement.offsetHeight;
                  if (childHeight > maxHeight) {
                    targetHeight = '100%';
                  } else {
                    targetHeight = "".concat(childHeight, "px");
                  }
                }
                if (height === TransitionHeightMode.Full) {
                  targetHeight = '100%';
                }
                this.onTransitionEnd = function () {
                  _this2.containerEl.removeEventListener('transitionend', _this2.onTransitionEnd);
                  _this2.containerEl.removeEventListener('transitioncancel', _this2.onTransitionEnd);
                  _this2.childEl.style.overflowY = null;
                  _this2.childEl.style.height = null;
                  _this2.onTransitionEnd = null;
                  _this2.containerEl.style.height = height;
                };
                // Need to listen for transitioncancel as well which can happen if a new transition interrupts
                // one already in progress.
                this.containerEl.addEventListener('transitionend', this.onTransitionEnd);
                this.containerEl.addEventListener('transitioncancel', this.onTransitionEnd);

                // Apply container height explicitly to trigger a transition. Once it completes we can revert
                // explicit styles and allow the layout to render naturally.
                this.containerEl.style.height = targetHeight;
              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function transitionTo(_x, _x2) {
        return _transitionTo.apply(this, arguments);
      }
      return transitionTo;
    }()
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        ref: this.containerRef,
        className: (0, _classnames.default)('transition-height', {
          // @TODO: this doesn't really work when height is auto but content takes up full height
          'rounded-t-[8px]': this.props.height === TransitionHeightMode.Auto
        }, this.props.className)
      }, /*#__PURE__*/_react.default.createElement("div", {
        ref: this.childRef,
        className: "transition-height-child"
      }, this.props.children));
    }
  }]);
  return TransitionHeight;
}(_react.default.Component);
var _default = TransitionHeight;
exports.default = _default;